import React, { useState } from "react";
import MapDistanceCalculator from "./MapsDistancia";
import styled from "styled-components";
import { FormGroup } from "./CostCalculadora";
import { EstiloButton, Alert, CloseButton } from "./App";
import logoCata from "./assets/logo_cata.png";
import PresupuestoApp from "./PresupuestoApp";
import { useData } from "./DataContext";

const Contenedor = styled.div`
  width: 100%;
  margin: 1rem 0rem 3.5rem 0rem;
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
  p {
    font-size: small;
    margin: 0px;
  }
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    justify-content: center;
  }
`;
const ContenedorDistancia = styled.div`
  margin: 0.7rem 1rem 0 1rem;
  width: 350px;
`;
const ContenedorForm = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 350px;
  margin: 0.7rem 1rem 0 1rem;
`;
const FormCotizador = styled.form`
  text-align: left;
  margin-bottom: 1rem;
`;
const ContenedorResultado = styled.div`
  right: 0;
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
  align-items: center;
  width: 300px;
`;
const ResultadoForm = styled.div`
  position: fixed;
  background-color: #6161612f;
  margin: 0.7rem 1rem 0 1rem;
  border-radius: 3px;
  width: 300px;
  height: auto;
  background-image: url(${logoCata});
  background-repeat: no-repeat;
  background-size: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: 1rem;
  h5 {
    margin-top: 4rem;
    margin-bottom: 0px;
  }
  @media (max-width: 1070px) {
    position: static;
  }
`;
const ResultadoLine = styled.div`
  margin: 6px 0 6px;
  width: 100%;
  height: 1px;
  background-color: rgb(0, 0, 0);
`;

function Formulario({
  mostrarDivForm,
  mostrarDivMaps,
  perfil,
  isDarkMode,
  mostrarPresupuesto,
}) {
  /*///////////////dataContext/////////////////////////*/
  const {
    sueldoData,
    viaticosNacionalesData,
    viaticosInternacionalesData,
    baseData,
    tasaData,
    costoUnidadesData,
  } = useData();
  const tasa = tasaData[0]?.tasa;
  const btm = baseData[0]?.base;
  const sueldoChofer = sueldoData[0]?.sueldo;
  const {
    almuerzo: almuerzoNacional,
    cama: camaNacional,
    cena: cenaNacional,
    desayuno: desayunoNacional,
    merienda: meriendaNacional,
  } = viaticosNacionalesData[0] || {};
  const totalViaticosNacionalesMasPersonal =
    almuerzoNacional +
    camaNacional +
    cenaNacional +
    desayunoNacional +
    meriendaNacional +
    (sueldoChofer * 1.6 * 1.083) / 26;

  const {
    almuerzo: almuerzoInternacional,
    cama: camaInternacional,
    cena: cenaInternacional,
    desayuno: desayunoInternacional,
    merienda: meriendaInternacional,
  } = viaticosInternacionalesData[0] || {};
  const totalViaticosInternacionalesMasPersonal =
    almuerzoInternacional +
    camaInternacional +
    cenaInternacional +
    desayunoInternacional +
    meriendaInternacional +
    (sueldoChofer * 1.6 * 1.083) / 26;

  const { costoBusDoble: costoBusDobleData, costoBus40: costoBus40Data } =
    costoUnidadesData[0] || {};

  /*////////////////////////////////////////*/

  const [baseTarifaria, setBaseTarifaria] = useState(btm);
  const [servicio, setServicio] = useState("nacional");
  const [fecha, setFecha] = useState("enero");
  const [cliente, setCliente] = useState("eventual");
  const [unidad, setUnidad] = useState("Bus Doble");
  const [tipo, setTipo] = useState("");
  const [cantidadUnidades, setCantidadUnidades] = useState("");
  const [cantidadPasajeros, setCantidadPasajeros] = useState("");
  const [servicioViaje, setServicioViaje] = useState("ida");
  const [kilometros, setKilometros] = useState("");
  const [kmVacios, setKmVacios] = useState("0");
  const [movimientosDestino, setMovimientosDestino] = useState("0");
  const [diasEstadia, setDiasEstadia] = useState("0");
  const [otros, setOtros] = useState("0");
  const [viaticosPersonal, setViaticosPersonal] = useState("");
  const [calculated, setCalculated] = useState(false);
  const [totalPresupuestado, setTotalPresupuestado] = useState("");
  const [precioPorButaca, setPrecioPorButaca] = useState("");
  const [precioPorTramo, setPrecioPorTramo] = useState("");
  const [pesoPorKm, setPesoPorKm] = useState("");
  const [kmCotizados, setKmCotizados] = useState("");
  let [totalTasa, setTotalTasa] = useState("");
  const [costoPesoPorKm, setCostoPesoPorKm] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  const closeAlert = () => {
    setShowAlert(false);
  };

  const calcular = () => {
    if (
      !cantidadUnidades ||
      !cantidadPasajeros ||
      !kilometros ||
      !baseTarifaria ||
      !kmVacios ||
      !movimientosDestino ||
      !diasEstadia ||
      !otros ||
      !tipo ||
      cantidadUnidades < 1 ||
      cantidadPasajeros < 1 ||
      kilometros < 1 ||
      baseTarifaria < 1 ||
      kmVacios < 0 ||
      movimientosDestino < 0 ||
      diasEstadia < 0 ||
      otros < 0
    ) {
      setShowAlert(true);
      return;
    }

    const btmValue = parseFloat(
      unidad === "Bus Doble" ? btm : costoBus40Data / 40
    );
    const cantidadUnidadesValue = parseInt(cantidadUnidades);
    const cantidadPasajerosValue = parseInt(cantidadPasajeros);
    const kilometrosValue = parseInt(kilometros > 60 ? kilometros : 60);
    let kmVaciosValue = parseInt(kmVacios);
    const movimientosDestinoValue = parseInt(movimientosDestino);
    const diasEstadiaValue = parseInt(diasEstadia);
    const otrosValue = parseInt(otros);
    let totalTasaValue = parseInt(totalTasa);

    const costoUnidad =
      unidad === "Bus Doble" ? costoBusDobleData : costoBus40Data;

    //60 km por dia de estadia
    const kmPorEstadia = diasEstadiaValue > 0 ? diasEstadiaValue * 60 : 0;

    kmVaciosValue += kmPorEstadia;

    const costoKmVacioValue = kmVaciosValue * costoUnidad * cantidadUnidades;

    const totalKM = kilometrosValue + movimientosDestinoValue;

    /*factor estacionalidad*/
    const fechaValor =
      fecha === "diciembre" ||
      fecha === "enero" ||
      fecha === "febrero" ||
      fecha === "marzo"
        ? 1.6
        : 1.4;

    /*base tarifaria = base tar. media x factor estac.*/
    const bta = btmValue * fechaValor;
    let tarifa = 0;

    /* Semicama, entre 10% Y 30% sobre bta */
    /*factor de variacion de 5% hasta 30%*/
    if (servicio === "internacional") {
      tarifa = bta * 1.7 * totalKM * 1.1;
    } else if (servicio === "nacional") {
      if (unidad === "Bus 40") {
        if (cliente === "eventual") {
          tarifa = bta * 1.1 * totalKM * 1.05;
        } else if (cliente === "canje") {
          tarifa = bta * 1.1 * totalKM * 1.1;
        } else if (cliente === "gobierno") {
          tarifa = bta * 1.1 * totalKM * 1.15;
        }
      } else if (unidad === "Bus Doble") {
        if (cliente === "eventual") {
          tarifa = bta * 1.15 * totalKM * 1.05;
        } else if (cliente === "canje") {
          tarifa = bta * 1.15 * totalKM * 1.1;
        } else if (cliente === "gobierno") {
          tarifa = bta * 1.15 * totalKM * 1.15;
        }
      }
    }

    if (servicio === "nacional" && servicioViaje === "ida") {
      totalTasaValue = tasa * cantidadPasajerosValue;
    } else if (servicio === "nacional" && servicioViaje === "ida-vuelta") {
      totalTasaValue = tasa * cantidadPasajerosValue * 2;
    } else {
      totalTasaValue = 0;
    }

    if (unidad === "Bus 40") {
      totalTasaValue = 0;
    }

    const capacidadBusDoble = 60;
    const capacidadBus40 = 40;
    const porcentajeMinimo = 0.7;

    let cantidadPaxMedia;
    let pasajerosPorUnidad = cantidadPasajerosValue / cantidadUnidadesValue;

    if (unidad === "Bus Doble") {
      cantidadPaxMedia =
        pasajerosPorUnidad > capacidadBusDoble * porcentajeMinimo
          ? pasajerosPorUnidad
          : capacidadBusDoble * porcentajeMinimo;
    } else if (unidad === "Bus 40") {
      cantidadPaxMedia =
        pasajerosPorUnidad > capacidadBus40 * porcentajeMinimo
          ? pasajerosPorUnidad
          : capacidadBus40 * porcentajeMinimo;
    }

    if (tipo === "cama42") {
      cantidadPaxMedia = 50;
    } else if (tipo === "cama37") {
      cantidadPaxMedia = 45;
    }

    const totalTarifaMicro = tarifa * cantidadPaxMedia;

    const choferesPorUnidad = kilometrosValue > 200 ? 2 : 1;

    const viaticoPorUnidad =
      diasEstadiaValue > 0
        ? viaticosPersonal * choferesPorUnidad * diasEstadiaValue
        : 0;

    let totalPresupuestadoValue =
      (totalTarifaMicro + viaticoPorUnidad) * cantidadUnidadesValue +
      (otrosValue + totalTasaValue + costoKmVacioValue);

    totalPresupuestadoValue = Math.round(totalPresupuestadoValue);

    //calculo para presentar precios por butaca, por tramos, $/km
    const precioPorButacaValue = Math.round(
      servicioViaje === "ida-vuelta"
        ? totalPresupuestadoValue / cantidadPasajerosValue
        : 0
    );
    const precioPorTramoValue = Math.round(
      servicioViaje === "ida"
        ? totalPresupuestadoValue / cantidadPasajerosValue
        : precioPorButacaValue / 2
    );

    let pesoPorKmValue = Math.round(
      totalPresupuestadoValue / (totalKM * cantidadUnidadesValue)
    );
    const kmCotizados = parseInt(totalKM) * cantidadUnidadesValue;

    setTotalPresupuestado(totalPresupuestadoValue);
    setPrecioPorButaca(precioPorButacaValue);
    setPrecioPorTramo(precioPorTramoValue);
    setPesoPorKm(pesoPorKmValue);
    setCalculated(true);
    setKmCotizados(kmCotizados);
    setUnidad(unidad);
    setTotalTasa(totalTasaValue);
    setCostoPesoPorKm(costoUnidad);
    setBaseTarifaria(btmValue);
  };

  function renderFormularioTerminal() {
    if (perfil === "terminal") {
      return (
        <FormGroup>
          <label htmlFor="kilometros">Kilómetros:</label>
          <input
            type="number"
            id="kilometros"
            name="kilometros"
            value={kilometros}
            onChange={(e) => setKilometros(e.target.value)}
            required
          />
        </FormGroup>
      );
    } else {
      return (
        <div>
          <FormGroup>
            <label htmlFor="kilometros">Kilómetros (por Bus):</label>
            <input
              type="number"
              id="kilometros"
              name="kilometros"
              value={kilometros}
              onChange={(e) => setKilometros(e.target.value)}
              required
            />
          </FormGroup>
          <FormGroup>
            <label htmlFor="km-dias-perdidos">Km vacíos (por Bus):</label>
            <input
              type="number"
              id="km-dias-perdidos"
              name="km-dias-perdidos"
              value={kmVacios}
              onChange={(e) => setKmVacios(e.target.value)}
              required
            />
          </FormGroup>
          <FormGroup>
            <label htmlFor="movimientos-destino">Mov. (Km por Bus):</label>
            <input
              type="number"
              id="movimientos-destino"
              name="movimientos-destino"
              value={movimientosDestino}
              onChange={(e) => setMovimientosDestino(e.target.value)}
              required
            />
          </FormGroup>
          <FormGroup>
            <label htmlFor="dias-estadia">Días de Estadía:</label>
            <input
              type="number"
              id="dias-estadia"
              name="dias-estadia"
              value={diasEstadia}
              onChange={(e) => setDiasEstadia(e.target.value)}
              required
            />
          </FormGroup>
          <FormGroup>
            <label htmlFor="otros">Otros:</label>
            <input
              type="number"
              id="otros"
              name="otros"
              value={otros}
              onChange={(e) => setOtros(e.target.value)}
              required
            />
          </FormGroup>
          <FormGroup>
            <label>Viáticos más Personal:</label>
            <select
              value={viaticosPersonal}
              onChange={(e) => setViaticosPersonal(e.target.value)}
            >
              <option value="0">No corresponde</option>
              <option value={totalViaticosNacionalesMasPersonal}>
                Nacional
              </option>
              <option value={totalViaticosInternacionalesMasPersonal}>
                Internacional
              </option>
            </select>
          </FormGroup>
        </div>
      );
    }
  }

  return (
    <Contenedor>
      {showAlert && (
        <Alert>
          <CloseButton onClick={closeAlert}>&times;</CloseButton>
          Por favor, complete todos los campos.
        </Alert>
      )}
      {mostrarDivMaps && (
        <ContenedorDistancia>
          <MapDistanceCalculator />
        </ContenedorDistancia>
      )}

      {mostrarDivForm && (
        <ContenedorForm>
          {perfil === "terminal" || perfil === "turismo" ? (
            <h4>Proyección de tarifas</h4>
          ) : (
            <h4>Servicios Especiales</h4>
          )}
          <FormCotizador id="formulario1">
            <FormGroup>
              <label htmlFor="baseTarifaria">BTM:</label>
              <input
                type="text"
                id="baseTarifaria"
                name="baseTarifaria"
                value={baseTarifaria}
                onChange={(e) => setBaseTarifaria(e.target.value)}
                required
              />
            </FormGroup>
            <FormGroup>
              <label htmlFor="servicio">Servicio:</label>
              <select
                id="servicio"
                name="servicio"
                value={servicio}
                onChange={(e) => setServicio(e.target.value)}
              >
                <option value="nacional">Nacional</option>
                <option value="internacional">Internacional</option>
              </select>
            </FormGroup>
            <FormGroup>
              <label htmlFor="fecha">Fecha de Viaje:</label>
              <select
                id="fecha"
                name="fecha"
                value={fecha}
                onChange={(e) => setFecha(e.target.value)}
              >
                <option value="enero">Enero</option>
                <option value="febrero">Febrero</option>
                <option value="marzo">Marzo</option>
                <option value="abril">Abril</option>
                <option value="mayo">Mayo</option>
                <option value="junio">Junio</option>
                <option value="julio">Julio</option>
                <option value="agosto">Agosto</option>
                <option value="septiembre">Septiembre</option>
                <option value="octubre">Octubre</option>
                <option value="noviembre">Noviembre</option>
                <option value="diciembre">Diciembre</option>
              </select>
            </FormGroup>

            {perfil === "terminal" ? null : (
              <FormGroup>
                <label htmlFor="cliente">Cliente:</label>
                <select
                  id="cliente"
                  name="cliente"
                  value={cliente}
                  onChange={(e) => setCliente(e.target.value)}
                >
                  <option value="eventual">Eventual</option>
                  <option value="canje">Canje</option>
                  <option value="gobierno">Gobierno</option>
                </select>
              </FormGroup>
            )}
            <FormGroup>
              <label htmlFor="unidad">Unidad:</label>
              <select
                id="unidad"
                name="unidad"
                value={unidad}
                onChange={(e) => setUnidad(e.target.value)}
              >
                <option value="Bus Doble">BusDoble</option>
                <option value="Bus 40">Bus40</option>
              </select>
            </FormGroup>
            <FormGroup>
              <label htmlFor="tipo">Tipo:</label>
              <select
                id="tipo"
                name="tipo"
                value={tipo}
                onChange={(e) => setTipo(e.target.value)}
              >
                <option value="">seleccionar</option>
                <option value="semicama">Semicama / Mix</option>
                <option value="cama42">cama42</option>
                <option value="cama37">cama37 / suite26</option>
              </select>
            </FormGroup>
            <FormGroup>
              <label htmlFor="cantidad-unidades">Cantidad de Unidades:</label>
              <input
                type="number"
                id="cantidad-unidades"
                name="cantidad-unidades"
                value={cantidadUnidades}
                onChange={(e) => setCantidadUnidades(e.target.value)}
                required
              />
            </FormGroup>
            <FormGroup>
              <label htmlFor="cantidad-pasajeros">Cantidad de Pasajeros:</label>
              <input
                type="number"
                id="cantidad-pasajeros"
                name="cantidad-pasajeros"
                value={cantidadPasajeros}
                onChange={(e) => setCantidadPasajeros(e.target.value)}
                required
              />
            </FormGroup>
            <FormGroup>
              <label htmlFor="servicio-viaje">Servicio:</label>
              <select
                id="servicio-viaje"
                name="servicio-viaje"
                value={servicioViaje}
                onChange={(e) => setServicioViaje(e.target.value)}
              >
                <option value="ida">Ida</option>
                <option value="ida-vuelta">Ida y Vuelta</option>
              </select>
            </FormGroup>

            {totalTasa < 1 ? (
              <></>
            ) : (
              <p style={{ fontWeight: "bold" }}>
                Tasa de embarque ${totalTasa}
              </p>
            )}

            {renderFormularioTerminal()}
          </FormCotizador>
          <EstiloButton type="button" id="calcular" onClick={calcular}>
            Calcular
          </EstiloButton>
        </ContenedorForm>
      )}

      {mostrarPresupuesto && <PresupuestoApp isDarkMode={isDarkMode}/>}

      {calculated ? (
        <ContenedorResultado>
          <ResultadoForm>
            <h5>Servicio {servicio}</h5>
            <strong>
              <span>{unidad}</span>
            </strong>
            {perfil === "terminal" || perfil === "turismo" ? (
              <span>
                Total Unidad:{" "}
                <strong>${totalPresupuestado.toLocaleString("es-AR")}</strong>
              </span>
            ) : (
              <span>
                Total Presupuestado:{" "}
                <strong>${totalPresupuestado.toLocaleString("es-AR")}</strong>
              </span>
            )}
            <span>
              Cantidad de Unidades: <strong>{cantidadUnidades}</strong>
            </span>
            <span>
              Pasajeros: <strong>{cantidadPasajeros}</strong>
            </span>
            <span>
              <strong>Precio por Butaca</strong>
            </span>
            <span>
              Ida y vuelta:{" "}
              <strong>${precioPorButaca.toLocaleString("es-AR")}</strong>
            </span>
            <span>
              Solo ida:{" "}
              <strong>${precioPorTramo.toLocaleString("es-AR")}</strong>
            </span>
            <span>
              Cantidad de Km: <strong>{kmCotizados}</strong>
            </span>
            <span>
              Peso por Km: <strong>${pesoPorKm.toLocaleString("es-AR")}</strong>
            </span>
            <ResultadoLine></ResultadoLine>
            <span>
              Costo $ por Km: <strong>${costoPesoPorKm}</strong>
            </span>
          </ResultadoForm>
        </ContenedorResultado>
      ) : ( null )}
    </Contenedor>
  );
}

export default Formulario;
